import { Navigate, RouteProps } from "react-router-dom";
import { useAuth } from "../components/auth/identity-auth0-context";
import LoadingScreen from "../components/progress/loading-screen";
import { ROLES } from "../constants";
import ROUTES from "./constants";
import useIsFlagEnabled from "../components/launchdarkly/use-is-flag-enabled";
import { LDFlagKey } from "../components/launchdarkly/flags";

type PrivateRouteProps = {
  requiredPermission?: string | null;
  ldFlag?: LDFlagKey;
  children: JSX.Element;
} & RouteProps;

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  requiredPermission = null,
  ldFlag,
  children,
}) => {
  const isFlagEnabled = useIsFlagEnabled();
  const { isAuthenticated, isLoading, userRoles, hasAccess } = useAuth();

  if (isAuthenticated && isLoading) {
    return <LoadingScreen />;
  }

  if (ldFlag && !isFlagEnabled(ldFlag)) {
    return <Navigate to={ROUTES.NOT_FOUND} />;
  }

  if (isAuthenticated && !isLoading && !hasAccess(requiredPermission)) {
    if (userRoles?.length === 1) {
      if (userRoles.includes(ROLES.CLIENT))
        return <Navigate to={ROUTES.SEARCH} />;
      if (userRoles.includes(ROLES.MDA_ANALYST_USER))
        return <Navigate to={ROUTES.DATA_CLEANING} />;
    }
    return <Navigate to={ROUTES.NOT_AUTHORIZED} />;
  }

  return children;
};

export default PrivateRoute;
